// extracted by mini-css-extract-plugin
module.exports = {"root":"📦UnlinkedTagWarning__root--uoRRU","dim":"📦UnlinkedTagWarning__dim--e6Ivx","bigIcon":"📦UnlinkedTagWarning__bigIcon--2Lfz_"};